export const BillingPeriod = {
   MONTHLY: 'MONTHLY',
   QUARTERLY: 'QUARTERLY',
   SEMIANNUAL: 'SEMIANNUAL',
   YEARLY: 'YEARLY',
}

export const BillingPeriodText = {
   [BillingPeriod.MONTHLY]: 'Mensal',
   [BillingPeriod.QUARTERLY]: 'Trimestral',
   [BillingPeriod.SEMIANNUAL]: 'Semestral',
   [BillingPeriod.YEARLY]: 'Anual',
}

export const BillingPeriodUnit = {
   [BillingPeriod.MONTHLY]: 'Mês',
   [BillingPeriod.QUARTERLY]: 'Trimestre',
   [BillingPeriod.SEMIANNUAL]: 'Semestre',
   [BillingPeriod.YEARLY]: 'Ano',
}

export const BillingPeriodMonths = {
   [BillingPeriod.MONTHLY]: 1,
   [BillingPeriod.QUARTERLY]: 3,
   [BillingPeriod.SEMIANNUAL]: 6,
   [BillingPeriod.YEARLY]: 12,
}

export const DiscountType = {
   Percentage: 'PERCENTAGE',
   Fixed: 'FIXED'
}

export const PaymentMethod = {
   Boleto: 'BOLETO',
   Pix: 'PIX',
   Credit: 'CREDIT',
   Debit: 'DEBIT',
   Wallet: 'WALLET'
}

export const PaymentMethodText = {
   [PaymentMethod.Boleto]: 'Boleto',
   [PaymentMethod.Pix]: 'Pix',
   [PaymentMethod.Credit]: 'Cartão de crédito',
   [PaymentMethod.Debit]: 'Cartão de débito',
   [PaymentMethod.Wallet]: 'Carteira digital',
};

export const DiscountOnAutomaticReadjustment = {
   Reset: 'RESET',
   KeepValue: 'KEEP_VALUE',
   RecalculateProportionally: 'RECALCULATE_PROPORTIONALLY',
}

export const DiscountOnAutomaticReadjustmentText = {
   [DiscountOnAutomaticReadjustment.Reset]: 'Resetar',
   [DiscountOnAutomaticReadjustment.KeepValue]: 'Manter o valor',
   [DiscountOnAutomaticReadjustment.RecalculateProportionally]: 'Recalcular proporcionalmente',
};